// extracted by mini-css-extract-plugin
module.exports = {"table":"DocumentTable_table_2IuEY","tbody":"DocumentTable_tbody_A4AMt","icon":"DocumentTable_icon_cigJf"};